import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navItems = [
        { path: '/admin/dashboard', label: 'Dashboard' },
        { path: '/admin/users', label: 'User Management' },
        { path: '/admin/audit-logs', label: 'Audit Logs' },
        { path: '/admin/analytics', label: 'Analytics' },
        { path: '/admin/partners', label: 'Partner Management' }
    ];

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <nav className="admin-nav">
            <div className="admin-nav-content">
                {navItems.map(item => (
                    <button
                        key={item.path}
                        className={`nav-button ${isActive(item.path) ? 'active' : ''}`}
                        onClick={() => navigate(item.path)}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default AdminNavigation;

